module.exports = __webpack_public_path__ + "static/media/6.a6ed60b1.jpg";